/* eslint import/no-extraneous-dependencies: 0 */
/* eslint no-underscore-dangle: 0 */
import * as Blockly from 'blockly';

// Replica el `field_string` del fork legacy (comillas alrededor del valor), que v13 no tiene.
// Las medidas son las del fork: sin las comillas los bloques con texto salen 16px más angostos que prod.
const QUOTE_WIDTH = 8;
const QUOTE_FONT_SIZE = 16;
const QUOTE_COLOR = '#a31515';

export class FieldString extends Blockly.FieldTextInput {
  initView() {
    super.initView();
    this.quoteLeft_ = this.createQuote_();
    this.quoteRight_ = this.createQuote_();
  }

  createQuote_() {
    const quote = Blockly.utils.dom.createSvgElement(
      'text',
      {
        class: 'field-text-quote',
        'font-size': `${QUOTE_FONT_SIZE}px`,
      },
      this.fieldGroup_,
    );
    // Por style y no por atributo: la regla CSS de Blockly para el texto de campos le gana a `fill`.
    quote.style.fill = QUOTE_COLOR;
    quote.appendChild(document.createTextNode('"'));
    return quote;
  }

  updateSize_(margin) {
    super.updateSize_(margin);
    if (!this.quoteLeft_ || !this.quoteRight_ || !this.textElement_) return;

    const textX = Number(this.textElement_.getAttribute('x')) || 0;
    const textY = this.textElement_.getAttribute('y');
    this.textElement_.setAttribute('x', String(textX + QUOTE_WIDTH));

    this.size_.width += QUOTE_WIDTH * 2;
    if (this.borderRect_) {
      this.borderRect_.setAttribute('width', String(this.size_.width));
    }

    this.positionQuote_(this.quoteLeft_, textX, textY);
    this.positionQuote_(this.quoteRight_, this.size_.width - textX - QUOTE_WIDTH, textY);
  }

  positionQuote_(quote, x, y) {
    quote.setAttribute('x', String(x));
    if (y !== null) quote.setAttribute('y', y);
    quote.setAttribute('dominant-baseline', this.textElement_.getAttribute('dominant-baseline') || 'central');
  }
}
